import {ListTable} from "./ListTable";
import {qualificationList} from "./const";
import {useContext} from "react";
import {Context} from "./context";

export const Qualification = ()=>{
    const {search} = useContext(Context);
    return <ListTable data={qualificationList
        .filter(it => Object.values(it).some(i=> {
            if (typeof i === 'string') return i.includes(search)
            else if (typeof i === 'number') return i.toString().includes(search);
            else return false;
        }))
    }/>
}
